// extracted by mini-css-extract-plugin
module.exports = {"AllowCode":"AllowCode_AllowCode__r8T_C","AllowCodeText":"AllowCode_AllowCodeText__ie99b"};